var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.alert.show),expression:"alert.show"}],staticClass:"alert",class:( _obj = {
    'animate': _vm.alert.animate
  }, _obj[_vm.alert.type] = _vm.alert.type, _obj )},[_c('span',[_vm._v(_vm._s(_vm.alert.message))]),_c('button',{on:{"click":_vm.closeAlert}},[_vm._v("X")])])}
var staticRenderFns = []

export { render, staticRenderFns }